export const configData = {
    SECRET_KEY: "shining-on-safety",// This SECRET_KEY crypto-js
    WEEK_ARRAY: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    MONTH_NAME: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    IP_INFO: "https://ipinfo.io/json?token=your_token"
}